const navLinks = [
  { id: "overview", label: "主题概览" },
  { id: "categories", label: "作品类型" },
  { id: "catalog", label: "作品目录" },
  { id: "collections", label: "合集组织" },
  { id: "series", label: "系列说明" },
  { id: "recommend", label: "推荐方向" },
  { id: "faq", label: "常见问题" },
];

const directionLinks = [
  { id: "catalog", label: "作品列表" },
  { id: "collections", label: "作品合集" },
  { id: "categories", label: "作品大全" },
  { id: "series", label: "作品系列" },
  { id: "recommend", label: "作品推荐" },
  { id: "overview", label: "作品介绍" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">三上悠亚电影</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              一个围绕「三上悠亚电影」整理浏览方向的中文单页资料站，按作品、合集、列表、大全、系列与推荐六个方向组织内容，
              并提供可在本页筛选检索的条目清单。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["作品", "合集", "列表", "大全", "系列", "推荐"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-100/25 px-3 py-1 text-xs text-background-100"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <nav aria-label="页内导航">
            <h3 className="font-heading text-sm font-semibold text-background-50">页内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容方向">
            <h3 className="font-heading text-sm font-semibold text-background-50">内容方向</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {directionLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} 三上悠亚电影 · 中文资料整理页 · 内容仅供成年浏览者参考
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs text-background-200 transition-colors hover:text-accent-400"
          >
            <i className="ri-arrow-up-line"></i>
            返回页面顶部
          </a>
        </div>
      </div>
    </footer>
  );
}